<template lang="pug">
.planboard-holder
  TopActions
  FetchErrorTransition(:isFetching="isPending" :error="fetchError" style="display: block;")
    PlanboardCalendar
</template>
<script>
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'
import TopActions from '@/vue/planboard/top-actions/TopActions.vue'
import PlanboardCalendar from '@/vue/planboard/planboard-calendar/PlanboardCalendar.vue'

export default {
  name: 'Planboard',
  components: {
    TopActions,
    PlanboardCalendar,
  },
  props: {
    resourceGroupKey: String,
    selectedDate: String,
  },
  computed: {
    ...mapGetters('planboardModule', ['isPending']),
    ...mapState('planboardModule', ['fetchError']),
  },
  methods: {
    ...mapActions('planboardModule', ['fetchPlanboardData']),
    ...mapMutations('planboardModule', ['setSelectedDate']),
  },
  async beforeMount() {
    this.setSelectedDate(this.selectedDate)
    await this.fetchPlanboardData()
  },
  watch: {
    async selectedDate() {
      await this.fetchPlanboardData()
    },
  },
}
</script>

<style scoped lang="stylus">
.planboard-holder
  position relative
  width 100%
</style>
